import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector, shallowEqual } from 'react-redux';


import { getFeeds, getFollowers, getUserData } from '../../api/feed'
import { FeedCard, Wallet, Suggested } from '../../components/feed'
import './feed.sass'

import { genNotificationToken } from '../../api/notification'
import { EmptyScreen } from '../../components/common/EmptyScreen';

import Usercard from '../../components/feed/Usercard'
import Header from "../../components/common/Header"

import { getSuggestedFollowers } from '../../api/feed'
import { useHistory } from 'react-router';
import { getFollowing } from '../../api/social';



export default function Feed() {
    const dispatch = useDispatch();
    const reduxPosts = useSelector(store => store.posts);
    const id = useSelector(store => store.userState.id);
    const [width, setWidth] = useState(document.body.clientWidth);
    const [isMobile, setIsMobile] = useState(false);
    const [suggestedList, setSuggestedList] = useState([]);
    const [posts, setPosts] = useState([]);
    const user = useSelector(state => state.userState)
    const history = useHistory();
    const [scrollPosition, setScrollPosition] = useState();
    const [isScrolled, setIsScrolled] = useState(true);
    const initialScrollPosition = useSelector(store => store.scrollPosition)
    const [feedloaded, setFeedloaded] = useState(false);

    // console.log(initialScrollPosition);


    const updateSuggestedFollowersList = async (id) => {
        const res = await getSuggestedFollowers(id);
        setSuggestedList(res);
    }

    useEffect(() => {

        if (id != undefined && id != null) {
            updateSuggestedFollowersList(id)
        }
    }, [id])

    const updateWidth = () => {
        setWidth(document.body.clientWidth)
    }

    useEffect(() => {
        window.addEventListener('resize', updateWidth);
        if (width > 850) {
            setIsMobile(false);
        } else {
            setIsMobile(true);
        }
    }, [width])

    let temp = []

    const getUserFollowing = async () => {
        var followings = await getFollowing(id)
        followings = followings.map(doc => doc.data().uid)
        getFeeds(async observer=>{
            console.log("CHANGE EVENT")
            temp = []
            for(var i = 0; i < observer.docs.length; i++){
                if(followings.includes(observer.docs[i].data().user)){
                    let post = observer.docs[i].data()
                    temp.push(post);
                }
            }
            setPosts(temp);
            dispatch({
                type: 'ADD_POST',
                payload: temp
            })
            setFeedloaded(true);
        })
    }

    const handleUpdatePosts = () => {
        getUserFollowing();
    }
    
    useEffect(() => {
        if (id)
            getUserFollowing();
    }, [id])



    useEffect(() => {
        document.getElementById('mainWrapper').classList.remove('post')
        document.getElementById('mainWrapper').classList.add('padding')
        document.getElementById('mobileNav').style.display = "flex"
        if(document.body.clientWidth < 580){
            document.getElementById('mainWrapper').style.cssText = "padding: 70px 10px 70px 10px !important"
            document.getElementById('desktopNav').style.display = 'flex'
        } else {
            document.getElementById('mainWrapper').style.cssText = "padding: 85px 0 0 0 !important"	
        }
    }, [])


    useEffect(() => {
        if (id != null && id != "" && id != undefined)
            genNotificationToken(id)
    }, [id])

    const explore = () => {
        history.push({
            pathname: '/search'
        })
    }

    function sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    useEffect(() => {

        console.log("we are executing the scroll effect")
        
        if(isScrolled){
            console.log("scrolling is enabled")
            if(initialScrollPosition){
                if(feedloaded){
                    console.log("we are scrollong now")
                    sleep(2000);
                    window.scrollTo({
                        left: 0,
                        top: initialScrollPosition,
                    })
                    setIsScrolled(false);
                }
            }
        }

    }, [feedloaded])

    const gotoProfile = () => {
        history.push({
            pathname: '/profile'
        })
        dispatch({ type: 'UPDATE_NAV', payload: {
            notification: false,
            home: false,
            search: false,
            post: false,
            chat: false,
            profile: true
        } })
    }

// this useEffect is used to set the scroll position on leaving
    useEffect(() => {
        window.onscroll = (position) => {
            console.log("we are at the position :", window.scrollY);
            setScrollPosition(window.scrollY);
            dispatch({
                type: "SET_SCROLL_POSITION",
                payload: window.scrollY,
            })
        }

        return () => {
            window.onscroll = null
            console.log(scrollPosition);
            console.log("//////////////////////////////////////////////////////////////////////")
            // dispatch({
            //     type: "SET_SCROLL_POSITION",
            //     payload: scrollPosition,
            // })
        }
    }, [])

    return (
        <div id="feedContainer">
            <div id="feedRow">
                <div id="feedCLeft">
                    {
                        (reduxPosts && reduxPosts.length === 0) ?
                            <EmptyScreen logo="home_a" description="Follow or subscribe Lovrs to start seeing the photos and videos they share" heading="Welcome to LOVR Online" btntext="Explore LOVR" handleClick={explore} /> :
                            reduxPosts.map((v) => <FeedCard
                                key={v.id}
                                likeMap={v.whoLiked}
                                bookmarkMap={v.whoBookmarked}
                                commentMap={v.whoCommented}
                                postId={v.id} 
                                user={v.user}
                                location={v.location}
                                image={v.media}
                                placeholder={v.placeholder}
                                body={v.body}
                                likesCount={v.likesCount}
                                commentsCount={v.commentsCount}
                                time={v.time} type={v.type} />)
                    }
                    {
                        (isMobile && reduxPosts.length == 0) ? <p className='mobile-suggested'>Suggested LOVRs</p> : ''
                    }
                    {
                        (isMobile && reduxPosts.length == 0) ? <div id="feedSuggestedList">{suggestedList && suggestedList.length > 0 ? suggestedList.map(user => <Usercard key={user.id} thumb={user.thumbnail} id={user.id} name={user.name} username={user.username} image={user.image} followers={user.followersCount} price={user.price} />) : <div> </div>}</div> : ''
                    }
                </div>
                <div id="feedCRight">
                    <div id="feedCRightWrapper">
                        <Header img="profile.svg" text={user.username} handleClick={gotoProfile} />
                        <div className="feedCRight-content">
                            <Wallet />
                            <Suggested onFollow={handleUpdatePosts} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
